import React, { useState, useEffect, useRef } from 'react';
import './Heroo.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Heroo = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const heroRef = useRef(null);
  
  const handleGetStarted = () => {
    console.log('Get Started clicked - scrolling to form');
    
    // Find the Form component in the DOM
    const formElement = document.querySelector('.form-section') || 
                       document.querySelector('.Form-container') || 
                       document.querySelector('[data-component="form"]');
    
    if (formElement) {
      // Smooth scroll to the form
      formElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
      
      // Optional: Add visual feedback on the form
      formElement.classList.add('form-highlight');
      setTimeout(() => {
        formElement.classList.remove('form-highlight');
      }, 2000);
      
    } else {
      // Fallback: Scroll to bottom if form not found
      console.warn('Form component not found. Scrolling to bottom.');
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  };

  // Alternative: If Form component has a ref
  const scrollToForm = () => {
    // You can also use this approach if Form component exposes a ref
    // This would require coordination between components
    
    // For now, using the DOM query approach above
    handleGetStarted();
  };

  // Simulate image loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setImageLoaded(true);
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="heroo-section" ref={heroRef}>
      {/* Dark Gradient Overlay */}
      <div className="heroo-overlay"></div>
      
      {/* Background Image in React */}
      <div className={`heroo-background ${imageLoaded ? 'loaded' : ''}`}>
        <img 
          src="./heroo.jpg" 
          alt="Hero Background"
          className="heroo-bg-image"
          onLoad={() => setImageLoaded(true)}
          loading="eager"
        />
      </div>

      <div className="heroo-container">
        {/* Left Content Column */}
        <div className="heroo-content">
          <h1 className="heroo-heading">
            <span className="heading-line line-1">Learn more about EZ Raider  </span>
            <span className="heading-line line-2">Our team is ready to help you </span>
          </h1>
          
          <div className="button-container">
            <button 
              className="heroo-button" 
              onClick={handleGetStarted}
              aria-label="Get started and scroll to contact form"
            >
              <span className="button-text">GET IN TOUCH</span>
              <ArrowForwardIcon className="button-icon" />
            </button>
          </div>
        </div>

        {/* Right Visual Column (empty - relies on background image) */}
        <div className="heroo-visual"></div>
      </div>
    </section>
  );
};

export default Heroo;